// src/redux/sagas/categoriesSaga.ts
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  fetchCategoriesRequest,
  fetchCategoriesSuccess,
  fetchCategoriesFailure,
  Category,
} from '../slices/categoriesSlice';
import ENDPOINTS from '../../api/endpoints';
import { request } from '../../api/request';

function* fetchCategoriesSaga(): Generator<any, void, any> {
  try {
    const apiUrl = `${ENDPOINTS.API_V2_BASE_URL}${ENDPOINTS.CATEGORIES_API_PATH}`;

    // Fetch categories from API
    const response = yield call(request, {
      url: apiUrl,
      method: 'GET',
    });

    if (response.success && response.data) {
      yield put(fetchCategoriesSuccess(response.data as Category[]));
    } else {
      yield put(fetchCategoriesFailure(response.message || 'Failed to fetch categories'));
    }
  } catch (error: any) {
    console.error('❌ Categories fetch error:', error);
    yield put(fetchCategoriesFailure(error.message || 'Failed to fetch categories'));
  }
}

export function* categoriesSaga() {
  yield takeLatest(fetchCategoriesRequest.type, fetchCategoriesSaga);
}
